import { Layout } from "./layout/Layout"

export const App = () => {
  return (
    <Layout/>
  )
}
